export interface ClickIds {
  gclid: string;
  msclkid: string;
  li_fat_id: string;
  fbclid: string;
}

/**
 * Extrait les click IDs connus depuis un objet de paramètres URL.
 * Retourne un objet avec toutes les clés présentes (strings vides si absentes).
 */
export function extractClickIds(params: Record<string, string>): ClickIds {
  return {
    gclid: params['gclid'] ?? '',
    msclkid: params['msclkid'] ?? '',
    li_fat_id: params['li_fat_id'] ?? '',
    fbclid: params['fbclid'] ?? '',
  };
}
